import { useRef } from 'react'

import { ClickAwayListener, Paper, Popper, Grow, styled } from '@mui/material'

import Gravatar from 'features/common/ui/utils/Gravatar'
import useOpenCloseHandler from 'features/common/ui/utils/useOpenCloseHandler'
import { getAvatarData } from 'features/users/model/user'

import { useMeUser } from 'features/users/hooks/useMeUser'

import UserAccount from './UserAccount'
import UserDetails from './UserDetails'
import UserActions from './UserActions'

const StyledPopper = styled(Popper)(({ theme }) => ({
  maxWidth: theme.spacing(40),
  minWidth: theme.spacing(30),
  zIndex: 1300
}))

const PopperGrow = styled(Grow)(() => ({
  transformOrigin: 'right top'
}))

const UserDialog = styled(Paper)(({ theme }) => ({
  overflow: 'hidden',
  marginTop: theme.spacing(0.5)
}))

function UserInfo({ showWorkspaceButton }: { showWorkspaceButton?: boolean }) {
  const user = useMeUser()
  const avatarData = getAvatarData(user)

  const { open, handleOpen, handleClose } = useOpenCloseHandler()
  const anchorRef = useRef<HTMLDivElement>(null)

  if (!user) return null

  return (
    <div ref={anchorRef}>
      <Gravatar {...avatarData} onClick={handleOpen} aria-label="User options" />
      <StyledPopper open={open} role={undefined} placement="bottom-end" transition anchorEl={anchorRef.current}>
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <PopperGrow {...TransitionProps} aria-label="User details">
              <UserDialog elevation={8}>
                <UserAccount user={user} />
                <UserDetails user={user} />
                <UserActions showWorkspaceButton={showWorkspaceButton} />
              </UserDialog>
            </PopperGrow>
          </ClickAwayListener>
        )}
      </StyledPopper>
    </div>
  )
}

export default UserInfo
